export default [

     {
          path: '/biadepartment-manager',
          name: 'BIADepartmentManager',
          component: () => import("@/views/Page/BIADepartmentManagerFormData/BIADepartmentManager.vue"),
          meta: {
               title: 'BIA Department Manager',
          },
     }
];